import { Tooltip } from "@mui/material";
import React from "react";
import moment from "moment";
import LocationPointIcon from "assets/svgIcons/ShareIcon";
import CloseIcon from "assets/svgIcons/ModalCloseOutIcon";
import { HoverWindow } from "commonComponents/HoleUI/CarsOnCourseStyled";
import SignalIcon from "assets/svgIcons/SignalIcon";
import { useSelector } from "react-redux";
import { reasonForReportString } from "constant";
import { useHookstate } from "@hookstate/core";
import { CAR_LOCATION_STATE, MAP_GLOBAL_STATES } from "globalStore/globalStore";
import { useTranslation } from "react-i18next";

export const HistoryIconPopup = (props) => {
  const { t } = useTranslation();
  const { siteSettingsData } = useSelector((state) => state.commonReducers) || [];
  const { showTaggedCar, specificCarTrackHistory } =  useHookstate(MAP_GLOBAL_STATES);
  const { carLocationBtn } = useHookstate(CAR_LOCATION_STATE);

  function hideLocation() {
    showTaggedCar.set(null);
    specificCarTrackHistory.set(false);
    carLocationBtn.set(false);

    let locationTrackingData = {
      carNumber: null,
      gpsiCarId: null,
      carType: null,
    };
    
    locationTrackingData = JSON.stringify(locationTrackingData);
    localStorage.setItem("locationTrackingData", locationTrackingData);
  }

  return (
    <HoverWindow style={{ position: "fixed", top: `${props.clickState.top}`, left: `${props.clickState.left}`}}>
      <div className="SignalIconCover">
        <SignalIcon width="16px" height="12.5px" color="gray" />
      </div>
      <div className="wrapper">
        <div className="close-icon-wrapper">
          <CloseIcon
            className="close-icon"
            onClick={() => props.setClickState({})}
          />
        </div>
        <div className="carSignalIcon">
          <h3>Car: {props.clickState?.data.CarNumber}</h3>
        </div>
        <p>
          {moment
            .utc(props.clickState?.data.LastLocationUpdateInUtc)
            .utcOffset(siteSettingsData && -siteSettingsData?.TimeZoneOffset)
            .format("DD-MMM-YYYY, h:mm a")}
        </p>
        {props.clickState?.data.PlayerName1 !== null ? (
          <p>{props.clickState?.data.PlayerName1}</p>
        ) : (
          <></>
        )}
        {props.clickState.data.PlayerName2 !== null ? (
          <p>{props.clickState?.data.PlayerName2}</p>
        ) : (
          <></>
        )}

        <p>
          <span style={{ fontSize: 16 }}>
            {props.clickState?.data.HoleLocation === 0
              ? "Not playing"
              : props.clickState?.data.HoleLocation === 1
              ? `Hole ${props.clickState?.data.Hole} Between Holes `
              : props.clickState?.data.HoleLocation === 2
              ? `Hole ${props.clickState?.data.Hole} Tee`
              : props.clickState?.data.HoleLocation === 3
              ? `Hole ${props.clickState?.data.Hole} Fairway`
              : props.clickState?.data.HoleLocation === 4
              ? `Hole ${props.clickState?.data.Hole} Green`
              : ""}
          </span>
          <br />
        </p>
        <p style={{ fontSize: "16px" }}>
          {props?.getPaceString(props.clickState?.data)}
        </p>
        <p>
          {t("Report_Reason")}:
          {reasonForReportString(
            props.clickState?.data.LocationReasonForReport
          )}
        </p>
        <p>
          {t("GPRS_Signal")}:{props.clickState?.data.LocationGprsSignalStrength}{" "}
        </p>
        <p>
          {t("Sequence")} #:{props.clickState?.data.LocationSequenceNumber}{" "}
        </p>
        <div className="icon-wrapper">
          <Tooltip title="Hide Location" arrow>
            <span
              onClick={hideLocation}
              className={
                showTaggedCar.get() === props.clickState?.data.CarNumber
                  ? "active"
                  : ""
              }
            >
              <LocationPointIcon color="var(--text-primary)" />
            </span>
          </Tooltip>
        </div>
      </div>
    </HoverWindow>
  );
};
